module.exports = __webpack_public_path__ + "static/media/Women_Rights_banner.364d5abf.png";